module.exports = __webpack_public_path__ + "img/globe.b2411e03.svg";